import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/auth/auth.service';
import { TableCommunicationService } from 'src/app/common/ag-grid-table/services/table-communication.service';
import { SpinnerService } from 'src/app/common/services/spinner.service';
import { PermissionsService } from 'src/app/permissions/service/permissions.service';

@Component({
  selector: 'app-users-and-security',
  templateUrl: './users-and-security.component.html',
  styleUrls: ['./users-and-security.component.sass']
})
export class UsersAndSecurityComponent implements OnInit {

  constructor(
    public authService: AuthService,
    private permissionsService: PermissionsService,
    private spinnerService: SpinnerService,
    private messageService: MessageService,
    private tableCommunicationService: TableCommunicationService,
  ) { }

  ngOnInit(): void {
    if (!this.authService.loadedPermissions()) {
      this.authService.loadPermissions().subscribe();
    }
  }

  async syncPermissions() {
    try {
      this.spinnerService.loadSpinner();

      const response = await this.permissionsService.syncPermissions();

      this.messageService.add({
        severity: 'success',
        summary: 'Sync Permissions',
        detail: response?.message ?? 'All permissions were sync',
      });

      this.tableCommunicationService.emitEvent('reloadDataSource');
    } catch (error) {
      console.log('error', error);
      let detail = '';

      if (error instanceof HttpErrorResponse) {
        detail = error.message;
      }

      this.messageService.add({
        severity: 'error',
        summary: 'Error Sync Permissions',
        detail,
      });
    } finally {
      this.spinnerService.endSpinner();
    }
  }
}
